<!-- eslint-disable vue/no-mutating-props -->
<template>
    <el-dialog
    :visible.sync="visible"
    title="客服电话"
    width="400px"
    center
    :before-close="cancelHandle"
    >
        <div class="tel">{{ businessTel }}</div>
        <div slot="footer">
          <div class="mt16" style="text-align: center">
            <el-button size="small" @click="cancelHandle">关闭</el-button>
          </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
  name: 'contactus', // 联系客服
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    businessTel: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    cancelHandle() {
      this.$emit('close')
    },
  },
}
</script>

  <style lang="scss" scoped>
  .tel {
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    line-height: 60px;
  }
  </style>
